import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=626a0eca&lang=scss&scoped=true"

import exportComponent from "/Library/WebServer/Documents/pt/qizhonghui/frontend/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.13_vue@3.4.19_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626a0eca"]])

export default __exports__